import React from "react";

export default function Footer() {
  return (
    <div className="bg-gray-800 p-4 text-[10px] text-center text-white">
      © Copyright 2025 NetmaxPlay - Todos los derechos reservados.
    </div>
  );
}
